module.exports = __webpack_public_path__ + "img/black-0.ea000b48.png";